const removeUrlSignature = (url) => {
	return url?.length ? url.split('?')[0] : ''
}

export default removeUrlSignature
